import { PlainSearchParameters } from 'algoliasearch-helper'
import { mapFacetFilters, normalizeFacetFilters } from '@app-domains/meilisearch/mappers/facet-filter.mapper'
import { DealerFilterInput, DealerSearchInput } from '@app-domains/meilisearch/types/dealer-search.types'
import { decodeDealerContext } from '@app-domains/meilisearch/types/search-request-context.types'

export function mapDealerInstantSearchRequest(params: PlainSearchParameters): DealerSearchInput {
    const context = decodeDealerContext(params as Record<string, unknown>)
    const facetFilters = normalizeFacetFilters(params.facetFilters as string | string[] | undefined)
    const widgetFilters = mapFacetFilters(facetFilters) as DealerFilterInput[]
    const facets = normalizeFacetsList(params.facets)

    return {
        query: params.query ?? '',
        page: (params.page ?? 0) + 1,
        perPage: params.hitsPerPage !== undefined ? params.hitsPerPage : 1500,
        filters: widgetFilters,
        facets,
        geo: context.geo,
    }
}

function normalizeFacetsList(facets: string | readonly string[] | undefined): string[] | undefined {
    if (facets == null) return undefined
    return typeof facets === 'string' ? [facets] : [...facets]
}
